import React from 'react';
import {TouchableOpacity, View, Text} from 'react-native';
import {format, isAfter, isToday} from 'date-fns';
import {colorPalette} from '@shared/config/colorsConfig';

type WeekDay = {
  id: string;
  label: string;
};

type DateInfo = {
  date: string;
  isToday: boolean;
  isSelected: boolean;
  fullDate: Date;
};

export const HistoryCalendar = ({
  weekDays,
  dates,
  handleDateSelect,
  statuses,
}: {
  weekDays: WeekDay[];
  dates: DateInfo[];
  handleDateSelect: (date: Date) => void;
  statuses?: any;
}) => {
  const isFutureDate = (date: Date) => {
    return isAfter(date, new Date()) && !isToday(date);
  };

  const getStatus = (date: Date) => {
    const dateStatus = statuses
      ? statuses[format(date, 'yyyy-MM-dd')]
      : undefined;
    return dateStatus === true ? 'blue' : dateStatus === false ? 'red' : 'none';
  };

  const getDateContainerStyle = (isSelected: boolean, isToday: boolean) => ({
    width: 40,
    height: 40,
    borderRadius: 20,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    marginBottom: 12,
    backgroundColor: isSelected || isToday ? colorPalette.secondary[100] : 'transparent',
    borderWidth: isSelected ? 1 : 0,
    borderColor: isSelected ? colorPalette.primary[600] : 'transparent',
    borderStyle: 'solid' as const,
  });

  return (
    <View className=" border-b border-gray-300 pb-5">
      <View className="flex-row justify-between py-[10px]">
        {weekDays.map((day, index) => {
          const date = dates[index].fullDate;
          const isFuture = isFutureDate(date);
          const status = getStatus(date);

          return (
            <TouchableOpacity
              key={day.id}
              className="items-center w-10"
              onPress={() => !isFuture && handleDateSelect(date)}
              disabled={isFuture}
              activeOpacity={0.7}>
              <View style={getDateContainerStyle(dates[index].isSelected, dates[index].isToday)}>
                <Text
                  className={`text-[18px] ${
                    dates[index].isSelected
                      ? 'text-primary-600 font-bold'
                      : isFuture
                      ? 'text-gray-500'
                      : ''
                  }`}>
                  {dates[index].date}
                </Text>
              </View>
              <Text
                className={`text-base ${
                  isFuture
                    ? 'text-gray-500'
                    : dates[index].isSelected
                    ? 'text-primary-600 font-bold'
                    : 'text-gray-500'
                }`}>
                {day.label}
              </Text>
              {status !== 'none' && !isFuture && (
                <View
                  className={`rounded-full mt-2 h-3 w-3 ${
                    status === 'red' ? 'bg-error-700' : 'bg-secondary-600'
                  }`}
                />
              )}
            </TouchableOpacity>
          );
        })}
      </View>
    </View>
  );
};
